import { render, staticRenderFns } from "./Watchlist.vue?vue&type=template&id=6e567e2f&scoped=true"
import script from "./Watchlist.vue?vue&type=script&lang=js"
export * from "./Watchlist.vue?vue&type=script&lang=js"
import style0 from "./Watchlist.vue?vue&type=style&index=0&id=6e567e2f&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e567e2f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e567e2f')) {
      api.createRecord('6e567e2f', component.options)
    } else {
      api.reload('6e567e2f', component.options)
    }
    module.hot.accept("./Watchlist.vue?vue&type=template&id=6e567e2f&scoped=true", function () {
      api.rerender('6e567e2f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/sidebar/Watchlist.vue"
export default component.exports